import { createSlice} from '@reduxjs/toolkit';
import AuthService from '../services/AuthService';
import i18n from '../i18n/config';
import { acl_check } from '../utils/aclUtils';
import { isSet } from '../utils/commonUtils';

/**
 * Pick the profile key to switch to after removal.
 * Prefer global admin (is_multiple_organization + organization-list) so that
 * "logout from one org" goes to org list instead of another org.
 * Debug: if redirect still wrong, log updateProfile keys and which key is returned.
 */
function getPreferredRemainingProfileKey(updateProfile) {
  const keys = Object.keys(updateProfile);
  if (keys.length === 0) return null;
  if (keys.length === 1) return keys[0];
  const globalAdminKey = keys.find((k) => {
    const p = updateProfile[k];
    const multiOrg = isSet(p?.is_multiple_organization, false) === true;
    const hasOrgList = acl_check(p?.permissions, 'organization-list') === true;
    return multiOrg && hasOrgList;
  });
  return globalAdminKey != null ? globalAdminKey : keys[keys.length - 1];
}


export const SessionSlice = createSlice({
  name: 'session',
  initialState: {
    profileDetails: {},
    profileStateList:[],
    access_token:null,
  },
  reducers: {
    setProfileDetails: (state,action) => {
      state.profileDetails = {
        ...state.profileDetails,
        [action.payload.key]: action.payload.value,
      };
    },
    removeProfile: (state,action) => {

      let updateProfile  = state.profileDetails;
      if (updateProfile.hasOwnProperty(action.payload.key)) {
        // Remove the object property with the specified key
        delete updateProfile[action.payload.key];
      }
      const keys = Object.keys(updateProfile);
      if(keys.length===0){
        state.profileDetails = updateProfile;
      }else{
        const nextKey = getPreferredRemainingProfileKey(updateProfile);
        if (nextKey != null) {
          AuthService.storeProfileId(updateProfile[nextKey].id);
          i18n.changeLanguage(updateProfile[nextKey]?.preferred_language || 'en');
        }
        state.profileDetails = updateProfile;
        // console.log('lastKeyValues',keys,updateProfile[lastKey].accessToken);
      }
        
    },
    setProfileStateList:(state,action)=>{
      // console.log("state",state,'actions',action);
      state.profileStateList=action.payload
    }
  },
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(fetchProfile.pending, (state) => {
  //       // state.status = 'loading';
  //     })
  //     .addCase(fetchProfile.fulfilled, (state, action) => {
  //       // state.status = 'succeeded';
  //       console.log('action',action);
  //       state.profileDetails = action.payload;
  //     })
  //     .addCase(fetchProfile.rejected, (state, action) => {
  //       // state.status = 'failed';
  //       state.error = action.error.message;
  //     });
  // },
});

export const { setProfileDetails,removeProfile,setProfileStateList} = SessionSlice.actions;
export const activeProfileDetails = (state) => state.session.profileDetails[AuthService.getProfileId()];
export default SessionSlice.reducer;